<div class="title" #title>
  <div class="container container-max-width">
    <h1 class="h4">Attest for S360 KPI</h1>
    <p style="line-height: 20px">
      Submit attestation for a team
      <br />
    </p>
  </div>
</div>

<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main">
    <form #TeamAttestForm="ngForm" autocomplete="off" style="height: 800px" novalidate>
      <!--ServiceTreeId-->
      <div class="form-group">
        <label id="ServiceTreeId-label" for="ServiceTreeId" class="form-label"><strong>Service Tree ID:</strong></label>
        <ng-select [(ngModel)]="serviceTreeId"
                   name="ServiceTreeId"
                   labelForId="ServiceTreeId"
                   [inputAttrs]="{ 'aria-labelledby': 'ServiceTreeId-label' }"
                   [items]="teamList"
                   bindLabel="label"
                   bindValue="value"
                   placeholder="Select service tree ID"
                   required>
        </ng-select>
        <em *ngIf="TeamAttestForm.controls.serviceTreeId?.invalid && TeamAttestForm.controls.serviceTreeId?.touched">Required</em>
      </div>

      <!--CloudName-->
      <div class="form-group">
        <label id="CloudName-label" for="CloudName" class="form-label"><strong>CloudName:</strong></label>
        <ng-select [(ngModel)]="cloudName"
                   name="CloudName"
                   labelForId="CloudName"
                   [inputAttrs]="{ 'aria-labelledby': 'CloudName-label' }"
                   [items]="cloudNameList"
                   bindLabel="label"
                   bindValue="value"
                   placeholder="Select cloud name"
                   required>
        </ng-select>
        <em *ngIf="TeamAttestForm.controls.cloudName?.invalid && TeamAttestForm.controls.cloudName?.touched">Required</em>
      </div>

      <!--Request Source-->
      <div class="form-group">
        <label id="RequestSource-label" for="RequestSource" class="form-label"><strong>Action Item Subtype:</strong></label>
        <ng-select [(ngModel)]="requestSource"
                   name="RequestSource"
                   labelForId="RequestSource"
                   [inputAttrs]="{ 'aria-labelledby': 'RequestSource-label' }"
                   [items]="requestSourceList"
                   bindLabel="label"
                   bindValue="value"
                   placeholder="Select Action Item Subtype"
                   required>
        </ng-select>
        <em *ngIf="TeamAttestForm.controls.requestSource?.invalid && TeamAttestForm.controls.requestSource?.touched">Required</em>
      </div>

      <div *ngIf="validationError" class="alert alert-danger">
        {{ validationError }}
      </div>

      <!--Submit Button-->
      <div class="form-group nofloat">
        <button type="submit"
                class="btn btn-primary me-1"
                [disabled]="TeamAttestForm.invalid"
                (click)="submitAttest()">
          Submit Attestation
        </button>
      </div>
      <hr />
      <br />
    </form>
  </div>
</div>
